module.exports = __webpack_public_path__ + "static/media/u-trapp-hoger.119a3fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/u-trapp-hoger.png
// module id = 40
// module chunks = 0